/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {ResponsiveHandler, RContainer} from '@gongxigames/framework/core/fragments/display/responsive';
import {FC, CanBeSignals, mapProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {ResponsiveConf} from '@gongxigames/framework/core/fragments/display/responsive';
import {slotStore} from '@gongxigames/framework/slotV2/globals/';
import {Rectangle} from 'pixi.js';
import {$BetSelectBasePopup} from './BetSelectBasePopup';
import {cacheAsSprite} from '@gongxigames/framework/core/fragments/display/CacheAsSprite';

export type BetSelectPopupPops = CanBeSignals<{
    bets: number[];
    bet: number;
    showPopup: boolean;
    onClose: () => void;
    onSetBetIndex: (index: number) => void;
}>;

const POPUP_POS_CONFIG_PORTRAIT: ResponsiveConf = {
    updateHeight: true,
    updateWidth: true,
    box: {x: '50%', y: '100%', width: '704px', height: '1346px'},
    translate: {x: '-50%', y: '-1536px'},
    scale: 1
};

const POPUP_POS_CONFIG_LANDSCAPE: ResponsiveConf = {
    updateHeight: true,
    updateWidth: true,
    box: {x: '100%', y: '100%', width: '704px', height: '1346px'},
    translate: {x: '-732px', y: '-1630px'},
    scale: 0.64
};

const POPUP_POS_CONFIG_GAME_RULES: ResponsiveConf = {
    updateHeight: true,
    updateWidth: true,
    box: {x: '0', y: '0', width: '704px', height: '1346px'},
};

export const $BetSelectPopup: FC<BetSelectPopupPops> = (props) => {
    const responsiveConfig = mapProp(slotStore.stage_isPortrait, isPortrait => {
        return isPortrait ? POPUP_POS_CONFIG_PORTRAIT : POPUP_POS_CONFIG_LANDSCAPE;
    });

    const gameRulesPopup = <$BetSelectBasePopup
        responsive={POPUP_POS_CONFIG_GAME_RULES}
        show={true}
        faderAlpha={0.0}
        onClose={props.onClose}
        onSetBetIndex ={props.onSetBetIndex}
        bets={props.bets}
        bet={props.bet}
    /> as RContainer;

    new ResponsiveHandler(gameRulesPopup).update();

    cacheAsSprite.add({
        name: 'game_rules_bet_select_popup',
        provider: gameRulesPopup,
        resolution: 0.25,
        region: new Rectangle(0, 0, 704, 1346),
    });

    return <$BetSelectBasePopup
        responsive={responsiveConfig}
        show={props.showPopup}
        onClose={props.onClose}
        onSetBetIndex ={props.onSetBetIndex}
        bets={props.bets}
        bet={props.bet}
    />;
};